
import Component from './component'

export default class DpdSlots extends Component {

    constructor() {

        super();
        this.init();    

    }

    init() {
        
        this.totalNoOfSlots = 12;
        this.cutOffBookingTimeForTomorrowSlots = 22;
        this.dpdSlots = [];
        this.setSlots();
        
    }

    setSlots() {
        
        const nth = function(d) {
            if (d > 3 && d < 21) return 'th';
            switch (d % 10) {
                case 1:  return "st";
                case 2:  return "nd";
                case 3:  return "rd";
                default: return "th";
            }
        }

        /** Date formate to backend server **/
        const dateformateser = function(dateObj) {
            const month=((dateObj.getMonth()+1)>=10)? (dateObj.getMonth()+1) : '0' + (dateObj.getMonth()+1);
            const date=((dateObj.getDate())>=10)? (dateObj.getDate()) : '0' + (dateObj.getDate());
            const formatedDate = dateObj.getFullYear() +''+ month +''+ date;
            return formatedDate;
        }

        /** Date formate to Display in front end **/
        const dateformatedis = function(dateObj) {
            const day = dateObj.toString().split(' ')[0];
            const date = dateObj.getDate();
            const month = dateObj.toLocaleString('default', { month: 'short' });
            const formatedDate = `${day} ${date}<sup>${nth(date)}</sup> ${month}`;
            return formatedDate;
        }

        Date.prototype.addDays = function(days) {
            this.setDate(this.getDate() + parseInt(days));
            return this;
        };

        /** Get the datetime from the url for testing slots 
        if nothing passed in the url then we get empty string from getParam
        Date formate should like this 2021-07-15 21:59:59 **/
        let dateTime = decodeURIComponent(this.getParam('datetime'));

        //dateTime = $("<div/>").html(dateTime).text();

        console.log(dateTime);

        //dateTime = '2021-07-20 21:59:59';

        let dateObj = new Date();

        if (dateTime != "") {

            dateObj = new Date(dateTime);
            
        }

        //this.dateObj = new Date();
        const bookingTime = dateObj.getHours();

        /*
            Booking Time = 00:00 >>> 22:00 = 1st Date Offered = D+1
            Booking Time = 22:01 >>> 23:59 = 1st Date Offered = D+2
        */
        if (bookingTime >= this.cutOffBookingTimeForTomorrowSlots) {

            dateObj.addDays(1);

        } 

        for(var key=1; key<=this.totalNoOfSlots; key++) {

            var slot = {};
            dateObj.addDays(1);
            slot['slotToDisplay'] = dateformatedis(dateObj); 
            slot['slotToSend'] = dateformateser(dateObj);
            this.dpdSlots.push(slot);

        }

    }

    getSlots() {

        return this.dpdSlots;

    }

}